import { css } from 'styled-components';

export const modalStyles = css`
  div.TCPModal__InnerContent.free-shipping-recs-content {
    right: 0;
    left: auto;
    top: 0;
    bottom: 0;
    transform: none;
    box-shadow: 0 4px 8px 0 rgba(163, 162, 162, 0.5);
    padding: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    @media ${(props) => props.theme.mediaQuery.medium} {
      width: 481px;
      animation: slide-in 0.5s forwards;
      overflow-y: scroll;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      animation: slide-in-mobile 0.5s forwards;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS}
        ${(props) => props.theme.spacing.ELEM_SPACING.XS} 0px 0px;
    }
    @keyframes slide-in {
      0% {
        transform: translateX(100%);
      }
      100% {
        transform: translateX(0%);
      }
    }
    @keyframes slide-in-mobile {
      0% {
        transform: translateY(100%);
      }
      100% {
        transform: translateY(5%);
      }
    }

    .close-modal {
      padding: 0;
      top: 18px;
      right: 33px;
      @media ${(props) => props.theme.mediaQuery.smallOnly} {
        right: 16px;
        top: 19px;
        height: 16px;
        width: 16px;
      }
    }
    .blurred-content {
      filter: blur(4px);
      -o-filter: blur(4px);
      -ms-filter: blur(4px);
      -moz-filter: blur(4px);
      -webkit-filter: blur(4px);
    }
    .Modal-Header {
      top: 0;
      position: sticky;
      z-index: 100;
      min-height: 51px;
      background: #f4f4f4;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .Modal_Heading {
      color: ${(props) => props.theme.colorPalette.gray[900]};
      display: block;
      font-family: Nunito;
      font-size: 16px;
      font-style: normal;
      font-weight: 700;
      line-height: 18px;
      border: none;
      padding: 0;
      margin: 0;
      @media ${(props) => props.theme.mediaQuery.smallMax} {
        margin: 18px auto 20px;
      }
    }
  }
  .quick-add-recs-wrapper {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 0 60px;
    row-gap: 10px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      padding: 18px 28px;
      row-gap: 28px;
      column-gap: 24px;
    }
    .recommendation-tile {
      width: 43%;
      margin: 16px 12px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin: 16px;
        width: 39%;
      }
    }
    .recommendation-tile-image {
      margin-bottom: 10px;
      @media ${(props) => props.theme.mediaQuery.medium} {
        margin-bottom: 16px;
      }
    }
    .recommendation-tile-atc-icon {
      margin-right: 9;
    }
    .product-name {
      font-weight: 500;
    }
  }
`;

export const productInfoStyles = css`
  margin-bottom: 10px;
  .product {
    margin: 0;
    width: 100%;
  }
`;
